import {
  AUDIO_BOUNDARY_REACHED,
  AUDIO_CANCEL,
  AUDIO_CANCEL_SUCCESS,
  AUDIO_CHANGE_RATE,
  AUDIO_CHANGE_RATE_SUCCESS,
  AUDIO_PAUSE,
  AUDIO_PAUSE_SUCCESS,
  AUDIO_PLAY,
  AUDIO_RESUME,
  AUDIO_RESUME_SUCCESS,
  AUDIO_SET_VOICE,
  AUDIO_SET_VOICE_SUCCESS,
  AUDIO_STOP_SUCCESS,
  JUMP_TO_WORD,
  REQUEST_OFFLINE_VOICES,
  REQUEST_OFFLINE_VOICES_SUCCESS,
  SKIP_TEXT_BACKWARD,
  SKIP_TEXT_FORWARD,
} from "./constants";
import {
  AudioBoundaryReached,
  AudioCancel,
  AudioCancelSuccess,
  AudioChangeRate,
  AudioChangeRateSuccess,
  AudioPause,
  AudioPauseSuccess,
  AudioResume,
  AudioResumeSuccess,
  AudioSetVoice,
  AudioSetVoiceSuccess,
  AudioStopSuccess,
  AudioPlay,
  RequestOfflineVoices,
  RequestOfflineVoicesSuccess,
  AudioSkipTextForward,
  AudioSkipTextBackward,
  AudioJumpToWord,
} from "./actionTypes";

import { IAudioPositionMarkers } from "./IAudioPositionMarkers";
import { IAudioVoice } from "./IAudioVoice";

export function requestOfflineVoices(): RequestOfflineVoices {
  return ({
    type: REQUEST_OFFLINE_VOICES,
  });
}

export function audioSetVoice(payload?: string): AudioSetVoice {
  return ({
    type: AUDIO_SET_VOICE,
    payload,
  });
}

export function audioSetVoiceSuccess(payload: string): AudioSetVoiceSuccess {
  return ({
    type: AUDIO_SET_VOICE_SUCCESS,
    payload,
  });
}

export function audioStopSuccess(): AudioStopSuccess {
  return ({
    type: AUDIO_STOP_SUCCESS,
  });
}

export function audioPlay(payload: boolean = false): AudioPlay {
  return ({
    type: AUDIO_PLAY,
    payload,
  });
}

export function audioPause(): AudioPause {
  return ({
    type: AUDIO_PAUSE,
  });
}

export function audioPauseSuccess(): AudioPauseSuccess {
  return ({
    type: AUDIO_PAUSE_SUCCESS,
  });
}

export function audioResume(): AudioResume {
  return ({
    type: AUDIO_RESUME,
  });
}

export function audioResumeSuccess(): AudioResumeSuccess {
  return ({
    type: AUDIO_RESUME_SUCCESS,
  });
}

export function changeRate(payload?: number): AudioChangeRate {
  return ({
    type: AUDIO_CHANGE_RATE,
    payload,
  });
}

export function audioChangeRateSuccess(payload: number): AudioChangeRateSuccess {
  return ({
    type: AUDIO_CHANGE_RATE_SUCCESS,
    payload,
  });
}

export function audioCancel(payload: boolean = false): AudioCancel {
  return ({
    type: AUDIO_CANCEL,
    payload,
  });
}

export function audioCancelSuccess(): AudioCancelSuccess {
  return ({
    type: AUDIO_CANCEL_SUCCESS,
  });
}

export function audioBoundaryReached(payload: IAudioPositionMarkers): AudioBoundaryReached {
  return ({
    type: AUDIO_BOUNDARY_REACHED,
    payload,
  });
}

export function requestOfflineVoicesSuccess(payload: Array<IAudioVoice>): RequestOfflineVoicesSuccess {
  return ({
    type: REQUEST_OFFLINE_VOICES_SUCCESS,
    payload,
  });
}


export function skipTextForward(payload?: number): AudioSkipTextForward {
  return ({
    type: SKIP_TEXT_FORWARD,
    payload,
  });
}

export function skipTextBackward(payload?: number): AudioSkipTextBackward {
  return ({
    type: SKIP_TEXT_BACKWARD,
    payload,
  });
}

export function jumpToWord(payload: number): AudioJumpToWord {
  return ({
    type: JUMP_TO_WORD,
    payload,
  });
}
